export {
    getAppDefinition,
    addDefinition,
    getStaticAppDefinitionsMap,
    isDataAvailablePriorToApolloInit,
} from './appDefinitions';
